module.exports = __webpack_public_path__ + "assets/client.8669e2c6.svg";